import { defineComponent as _defineComponent } from 'vue'
import OzContainedButton, { OzContainedButtonSizePreset } from '@@/library/v4/components/OzContainedButton.vue'
import OzInput, { OzInputSizePreset } from '@@/library/v4/components/OzInput.vue'
import { useDarkModeStore } from '@@/pinia/dark_mode'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PostConnectionOverlay',
  props: {
    xConnect: { type: Boolean },
    isStream: { type: Boolean }
  },
  emits: ["connect"],
  setup(__props: any) {





const tipColor = computed(() => {
  return useDarkModeStore().isDarkMode ? 'rgb(254, 192, 6, 0.06)' : 'rgb(148, 102, 232, 0.1)' // rgb values are taken from the tailwind bg classes below
})

const label = ref('')

return { __sfc: true,tipColor, label, OzContainedButton, OzContainedButtonSizePreset, OzInput, OzInputSizePreset }
}

})